import { render, staticRenderFns } from "./ResentNotificationDialog.vue?vue&type=template&id=5f2eb811&scoped=true"
import script from "./ResentNotificationDialog.vue?vue&type=script&lang=js"
export * from "./ResentNotificationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2eb811",
  null
  
)

export default component.exports